import React from 'react';
import { OFFER_ANCHOR, PRODUCT_IMAGE } from '../data/config';
type ProductImageProps = {
  className?: string;
  linkToOffer?: boolean;
};
export function ProductImage({
  className = '',
  linkToOffer = true
}: ProductImageProps) {
  const img = <img src={PRODUCT_IMAGE} alt="Pediatric OT Complete Therapy System™ — 6 professional volumes plus 5 free bonuses, 440 pages" className={`mx-auto block h-auto w-full object-contain ${className}`} data-id="element-171" data-mp="2lk5034httt34" />;
  if (!linkToOffer) return img;
  return <a href={OFFER_ANCHOR} aria-label="Go to the special offer" className="block" data-id="element-172" data-mp="27lf63xqb09iz">
      {img}
    </a>;
}